module.exports = __webpack_public_path__ + "static/media/23-apr25sep25.398577bf.pdf";